import { connect } from 'react-redux';

import {
  postIngredient,
  pushNotification,
  ingredientSearch,
  setIngredientSearchResults,
  setIngredientsSearchPhrase
} from '../../actions';
import IngredientPicker from '../components/IngredientPicker';

const mapStateToProps = state => {
  return {
    current_search_phrase: state.ingredients.search.current_search_phrase,
    results: state.ingredients.search.results
  };
}

const mapDispatchToProps = {
  postIngredient,
  pushNotification,
  ingredientSearch,
  setIngredientSearchResults,
  setIngredientsSearchPhrase
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IngredientPicker)
